import React, { Component } from 'react'

import PropTypes from 'prop-types'

import without from 'lodash/without'

import FilterDrawerComponent from './FilterDrawer.component'

class FilterDrawerContainer extends Component {
    static propTypes = {
      savedFilters: PropTypes.object,
      api: PropTypes.object,
      handleSaveFilters: PropTypes.func,
      handleFilterOpen: PropTypes.func,
      handleFilter: PropTypes.func,
      appliedFilters: PropTypes.object
    }

    constructor(props) {
      super(props)

      this.state = {
        appliedFilters: props.appliedFilters || {},
        saveFiltersChecked: false,
        validationErrors: false,
        validationErrorHandles: []
      }

      this.bodyEl = window.document.body
    }

    componentWillReceiveProps(newProps) {
      this.setOverflow(newProps.mobile)
    }

    componentWillUnmount() {
      this.setOverflow(false)
    }

    setOverflow(mobile) {
      if (mobile) {
        this.bodyEl.style.overflow = 'hidden'
      } else {
        this.bodyEl.style.overflow = 'auto'
      }
    }

    addAppliedFilter = (appliedFilter) => {
      const appliedFilters = Object.assign({}, this.state.appliedFilters)

      if (appliedFilter.action && appliedFilter.action === 'remove') {
        delete appliedFilters[appliedFilter.handle]
      } else {
        appliedFilters[appliedFilter.handle] = appliedFilter
      }
      this.setState({
        appliedFilters
      })
    }

    setAllFilters = (filtersArray) => {
      const newFilters = {}

      filtersArray.forEach((filterItem) => {
        newFilters[filterItem.handle] = filterItem
      })

      this.setState({
        appliedFilters: newFilters
      })
    }

    handleClickApplyFilters = () => {
      if (Object.keys(this.state.appliedFilters).length < 1) {
        return false
      }

      this.props.handleFilter(this.state.appliedFilters)

      if (this.state.saveFiltersChecked) {
        this.props.handleSaveFilters(this.state.appliedFilters)
      }

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Apply Filters',
        type: 'Datatable'
      })
    }

    handleSaveFiltersCheck = (status) => {
      this.setState({
        saveFiltersChecked: status
      })
    }

    handleClearFilters = () => {
      this.props.api.setCustomFilter(null)
      this.props.api.setCustomFilterId(null)
      this.props.api.setCustomFilterType(null)
      this.props.api.unsetSearch()
      this.setState({
        appliedFilters: {},
        validationErrors: false,
        validationErrorHandles: []
      })
      this.props.handleFilter({})

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Clear Filters',
        type: 'Datatable'
      })
    }

    handleClose = (evt) => {
      evt.preventDefault()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Close Filter Tray',
        type: 'Datatable'
      })

      this.props.handleFilterOpen()
    }

    handleInputValidationErrors = (input, error, handle) => {
      let arr = this.state.validationErrorHandles.slice()

      if (arr.indexOf(handle) > -1) {
        if (!error) {
          arr = without(arr, handle)
        }
      } else if (error) {
          arr.push(handle)
        }

      this.setState({validationErrors: error, validationErrorHandles: arr})
    }

    render() {
      const {
        extraFilters,
        savedFilters,
        quickFilters,
        headers,
        handleFilterOpen,
        handleRemove,
        handleRemoveFilter,
        i18n,
        api,
        analytics,
      } = this.props

      const {saveFiltersChecked, appliedFilters, validationErrorHandles} = this.state

      const events = {
        addAppliedFilter: this.addAppliedFilter,
        setAllFilters: this.setAllFilters,
        handleClickApplyFilters: this.handleClickApplyFilters,
        handleClearFilters: this.handleClearFilters,
        handleSaveFiltersCheck: this.handleSaveFiltersCheck,
        handleClose: this.handleClose,
        handleInputValidationErrors: this.handleInputValidationErrors
      }

      return (
        <FilterDrawerComponent
          analytics={analytics}
          extraFilters={extraFilters}
          savedFilters={savedFilters}
          quickFilters={quickFilters}
          headers={headers}
          handleFilterOpen={handleFilterOpen}
          i18n={i18n}
          api={api}
          handleRemove={handleRemove}
          saveFiltersChecked={saveFiltersChecked}
          appliedFilters={appliedFilters}
          events={events}
          validationErrors={validationErrorHandles.length > 0}
          handleRemoveFilter={handleRemoveFilter}
        />
      )
    }
}

export default FilterDrawerContainer
